/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface Service { 
    _id?: string;
    serviceId?: string;
    serviceName?: string;
    systemName?: string;
    status?: number;
    owner?: string;
    ownerId?: string;
    description?: string;
    createdDate?: Date;
    updatedDateTime?: Date;
    countryCodeIso?: string;
    countryCode?: string;
}